export const controlMenuPosition = {
  right: "auto",
  left: "10px",
  buttonRight: "auto",
  buttonLeft: "15px",
  buttonIcon: "fas fa-chevron-left"
};

export const vizContainerPosition = {
    right: "10px",
    left: "auto",
    buttonRight: "15px",
    buttonLeft: "auto",
};

export const basemapPosition = {
    top: 209,
    right: "10px",
    left: "auto",
    buttonRight: "15px",
    buttonLeft: "auto",
    buttonIcon: "fas fa-chevron-right"
};

export const overlaySelectionPosition = {
    top: 251,
    right: "10px",
    left: "auto",
    buttonRight: "15px",
    buttonLeft: "auto",
    buttonIcon: "fas fa-chevron-right"
};

export const homePosition = {
    top: 167,
    right: "10px",
    left: "auto",
    buttonRight: "15px",
    buttonLeft: "auto",
    buttonIcon: "fas fa-home"
};

export const tutorialPosition = {
    top: 335,
    right: "10px",
    left: "auto",
    buttonRight: "15px",
    buttonLeft: "auto",
    buttonIcon: "fas fa-info"
};

export const navControlPosition = {
    top: 17,
    right: 47,
    left: "auto",
};

export const appStatePosition = {
    top: 293,
    right: "10px",
    left: "auto",
    buttonRight: "15px",
    buttonLeft: "auto",
    buttonIconClosed: "fas fa-filter",
    buttonIconOpen: "fas fa-chevron-right",
};